module.exports = __webpack_public_path__ + "img/zw_wotg.5fff6a60.png";